module.exports = __webpack_public_path__ + "img/san-marino.0ffe6242.png";